import http from '@core/fetch'
import { getUrlParam } from '@core/utils'
import { getMerchantInfo } from '@util'

export default {
  poster: id => {
    const city = getMerchantInfo().city_code || getUrlParam('city')

    return http(
      '/p/wedding/index.php/home/APIPosterBlock/block_info?city=' +
        city +
        '&id=' +
        id
    )
  }
}
